//src/app/features/questionnaires/create/PrepareQuestionnaire/fields/individualFields.tsx
import { updateQuestionnaireRoutes } from 'app/features/questionnaires/edit/routes/slice';
import { store } from 'app/redux/store';
import { TaxFillingStatus } from 'app/services/user';
import { states } from 'states';
import * as Yup from 'yup';
import { commonFields, commonValidationObject } from '../fields';
import { PrepareQuestionnaireState, updateKey } from '../slice';
import { updateKey as nonUsFinancialAccountUpdateKey } from '../../../edit/TaxQuestionnaire/NonUSFinancialAccounts/NonUSFinancialAccounts/slice';

export const individualFields: IBaseField<keyof PrepareQuestionnaireState>[] = [
  ...commonFields,
  {
    type: 'radio',
    name: 'isAoaSubscriber',
    label: 'Are you an AOA Subscribed Client?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
  },
  {
    type: 'radio',
    name: 'married',
    label: 'Are you married?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
  },
  {
    label: 'What is your filing status?',
    effect: (payload) => store.dispatch(updateKey(payload)),
    name: 'whatIsYourFillingStatus',
    type: 'select',
    options: Object.values(TaxFillingStatus).map((status) => ({
      label: status,
      value: status,
    })),
  },
  {
    type: 'radio',
    name: 'haveChildren',
    label: 'Have children or dependents?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
  },
  {
    type: 'radio',
    name: 'paidByEmployer',
    label: 'Are you a W2 Employee?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'number',
        name: 'howManyW2SDoYouHave',
        label: "How many W2's do you have?",
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
      {
        type: 'radio',
        name: 'incomeOutsideUs',
        label: 'Income from outside the US?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },
      {
        type: 'radio',
        name: 'incomeFromUs',
        label: 'Income from the US?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'financialAccountsOutsideUs',
    label: 'Financial accounts outside US?',
    tooltip: '',
    effect: (payload) => {
      store.dispatch(updateKey(payload));
      store.dispatch(
        nonUsFinancialAccountUpdateKey({
          key: 'atAnyTimeDuringYearDidYouOwnAFinancialAccountsuchAsBankSavingsRetirementOrBrokerageAccountOutsideTheUnitedStates',
          value: payload.value,
        }),
      );
    },
    updateRemoteKey: () => {
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      );
    },
  },
  {
    type: 'radio',
    name: 'selfEmployed',
    label: 'Are you a Single Member of a business?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),

    dependencies: [
      {
        type: 'number',
        name: 'howManyBusinessesDoYouHaveWhereYouAreTheOnlyMember',
        label: 'How many businesses do you have where you are the only member?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'doYouHaveBusinessInterestInAPartnershipOrCorporationReceiveAK1Forms',
    label:
      'Do you have business interest in a Partnership or corporation (Receive a K1 Forms)?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'number',
        name: 'howManyDifferentBusinessesDoYouOwn',
        label: 'How many different businesses do you own?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'investments',
    label: 'Did you sell any Stock during the year?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'number',
        name: 'howManyBrokerageAccountsOrPlatformsDidYouUse_Investments',
        label: 'How many brokerage accounts or platforms did you use?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'reitermentAccount',
    label: 'Did you contribute to a retirement account?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'number',
        name: 'howMuchDidYouDeposit',
        label: 'How much did you deposit?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'soldProperty',
    label: 'Did you sell Property this year?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
  },
  {
    type: 'radio',
    name: 'earnInterest',
    label: 'Did you receive Interest Income?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'number',
        name: 'howManyForms1099IntDidYouReceive',
        label: 'How many forms 1099 INT did you receive?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'rentProperty',
    label: 'Did you you rent property as a Landlord?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'number',
        name: 'howManyRentalPropertiesDidYouHave',
        label: 'How many rental properties did you have?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'areAnyOfYourRentalPropertiesOutsideOfTheStateYouLiveIn',
    label:
      'Are any of your rental properties outside of the state you live in?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependencies: [
      {
        type: 'multi-state',
        name: 'whatStateIsThePropertyIn',
        label: 'What state is the property in?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'spouse',
    label: 'filing with a spouse?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    updateRemoteKey: () =>
      store.dispatch(
        updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
      ),
    dependentOn: 'prepareQuestionnaire.married',
    predicate: (value) => value === 'yes',

    dependencies: [
      {
        type: 'radio',
        name: 'spousewageIncome',
        label: 'wage income (spouse)?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },

      {
        type: 'radio',
        name: 'spousePension',
        label: 'pension (spouse)?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },
      {
        type: 'radio',
        name: 'spouseDivedends',
        label: 'Dividends (spouse)?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },
      {
        type: 'radio',
        name: 'spouseIncomeInterest',
        label: 'Interest Income (Spouse)?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        updateRemoteKey: () =>
          store.dispatch(
            updateQuestionnaireRoutes(store.getState().prepareQuestionnaire),
          ),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'areYouAnActiveMemberOfTheMilitary',
    label: 'Are you an active member of the military?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'radio',
        name: 'didYouMoveDuringTheYear',
        label: 'Did you move during the year?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
      {
        type: 'radio',
        name: 'areYouAVeteran',
        label: 'Are you a veteran?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'doYouOwnAHome',
    label: 'Do you own a home?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),

    dependencies: [
      {
        type: 'radio',
        name: 'didYouPurchaseAHomeInTheYearForThisFiling',
        label: 'Did you purchase a home in the year for this filing?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
  {
    type: 'radio',
    name: 'didYouEngageInCryptocurrency',
    label: 'Did you engage in cryptocurrency?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'number',
        name: 'howManyBrokerageAccountsPlatformsDidYouUse_Cryptocurrency',
        label: 'How many brokerage accounts/Platforms did you use?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },

  {
    type: 'radio',
    name: 'doYouHaveAFarm',
    label: 'Do you have a farm?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
  },

  {
    type: 'radio',
    name: 'didYouLiveOrWorkInMoreThanOneState',
    label: 'Did you live or work in more than one state?',
    tooltip: '',
    effect: (payload) => store.dispatch(updateKey(payload)),
    dependencies: [
      {
        type: 'number',
        name: 'howManyStateDidYouLiveOrWorkIn',
        label: 'How many?',
        tooltip: '',
        effect: (payload) => store.dispatch(updateKey(payload)),
        predicate: (value) => value === 'yes',
      },
    ],
  },
];

const requiredPositiveNumber = (dependent: string) => {
  return Yup.string().when(dependent, {
    is: 'yes',
    then: Yup.string()
      .nullable()
      .test('len', 'Invalid number', (val: any) => +val >= 0)
      .required('required'),
    otherwise: Yup.string().nullable(),
  });
};
const requiredString = (depenedentOn: string) => {
  return Yup.string().when(depenedentOn, {
    is: 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  });
};

export const validationSchema = Yup.object().shape({
  ...commonValidationObject,
  isAoaSubscriber: Yup.string().nullable().required('required'),
  married: Yup.string().nullable().required('required'),
  whatIsYourFillingStatus: Yup.string().nullable().required('required'),
  haveChildren: Yup.string().nullable().required('required'),
  paidByEmployer: Yup.string().nullable().required('required'),
  howManyW2SDoYouHave: requiredPositiveNumber('paidByEmployer'),
  incomeOutsideUs: Yup.string().when('paidByEmployer', {
    is: 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  incomeFromUs: Yup.string().when('paidByEmployer', {
    is: 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  financialAccountsOutsideUs: Yup.string().nullable().required('required'),
  selfEmployed: Yup.string().nullable().required('required'),
  howManyBusinessesDoYouHaveWhereYouAreTheOnlyMember:
    requiredPositiveNumber('selfEmployed'),
  investments: Yup.string().nullable().required('required'),
  howManyBrokerageAccountsOrPlatformsDidYouUse_Investments:
    requiredPositiveNumber('investments'),

  reitermentAccount: Yup.string().nullable().required('required'),
  howMuchDidYouDeposit: requiredPositiveNumber('reitermentAccount'),
  soldProperty: Yup.string().nullable().required('required'),
  earnInterest: Yup.string().nullable().required('required'),
  rentProperty: Yup.string().nullable().required('required'),
  howManyRentalPropertiesDidYouHave: requiredPositiveNumber('rentProperty'),
  spouse: Yup.string().when('married', {
    is: 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  spousewageIncome: Yup.string().when(['spouse', 'married'], {
    is: (spouse: string, married: string) =>
      spouse === 'yes' && married === 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  spousePension: Yup.string().when(['spouse', 'married'], {
    is: (spouse: string, married: string) =>
      spouse === 'yes' && married === 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  spouseDivedends: Yup.string().when(['spouse', 'married'], {
    is: (spouse: string, married: string) =>
      spouse === 'yes' && married === 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),
  spouseIncomeInterest: Yup.string().when(['spouse', 'married'], {
    is: (spouse: string, married: string) =>
      spouse === 'yes' && married === 'yes',
    then: Yup.string().nullable().required('required'),
    otherwise: Yup.string().nullable(),
  }),

  areAnyOfYourRentalPropertiesOutsideOfTheStateYouLiveIn: Yup.string()
    .nullable()
    .required('required'),
  whatStateIsThePropertyIn: Yup.array().when(
    'areAnyOfYourRentalPropertiesOutsideOfTheStateYouLiveIn',
    {
      is: 'yes',
      then: Yup.array().nullable().min(1, 'required').required('required'),
      otherwise: Yup.array().nullable(),
    },
  ),
  areYouAnActiveMemberOfTheMilitary: Yup.string()
    .nullable()
    .required('required'),
  didYouMoveDuringTheYear: requiredString('areYouAnActiveMemberOfTheMilitary'),
  areYouAVeteran: requiredString('areYouAnActiveMemberOfTheMilitary'),

  doYouOwnAHome: Yup.string().nullable().required('required'),
  didYouPurchaseAHomeInTheYearForThisFiling: requiredString('doYouOwnAHome'),

  didYouEngageInCryptocurrency: Yup.string().nullable().required('required'),
  howManyBrokerageAccountsPlatformsDidYouUse_Cryptocurrency:
    requiredPositiveNumber('didYouEngageInCryptocurrency'),

  doYouHaveAFarm: Yup.string().nullable().required('required'),

  doYouHaveBusinessInterestInAPartnershipOrCorporationReceiveAK1Forms:
    Yup.string().nullable().required('required'),
  howManyDifferentBusinessesDoYouOwn: requiredPositiveNumber(
    'doYouHaveBusinessInterestInAPartnershipOrCorporationReceiveAK1Forms',
  ),

  didYouLiveOrWorkInMoreThanOneState: Yup.string()
    .nullable()
    .required('required'),
  howManyStateDidYouLiveOrWorkIn: requiredPositiveNumber(
    'didYouLiveOrWorkInMoreThanOneState',
  ),

  howManyForms1099IntDidYouReceive: requiredPositiveNumber('earnInterest'),
});
